import { redirect } from "@tanstack/react-router";
import { store } from "@/lib/states/store";
import { PermissionsMap } from "@/lib/states/session/store";

export const hasPermission = (
  permissionKey: string,
  permissions?: PermissionsMap
) => Boolean((permissions ?? store.getState().session.permissions)?.[permissionKey]);

export const hasAnyPermission = (
  permissionKeys: string[],
  permissions?: PermissionsMap
) => permissionKeys.some((permissionKey) => hasPermission(permissionKey, permissions));

export const requirePermission = (permissionKey: string) => {
  if (!hasPermission(permissionKey)) {
    throw redirect({
      to: "/clients",
      replace: true,
    });
  }
};

export const requireAnyPermission = (permissionKeys: string[]) => {
  if (!hasAnyPermission(permissionKeys)) {
    throw redirect({
      to: "/clients",
      replace: true,
    });
  }
};
